module.exports = __webpack_public_path__ + "files/b1e318d8bbdae23d5177d0549e0a3197.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/sourcesanspro-bolditalic-webfont.eot
 ** module id = 434
 ** module chunks = 0
 **/